
export class CostDetailSearchCondition
{
    public empCd: string
    public targetDate: string
    public detailNo: number
}
